export const PRE_CONTRACTUAL_ENDPOINTS = {
    documents: '/loan-application/documents',
};
